import script from "./associate.vue?vue&type=script&lang=jsx&setup=true"
export * from "./associate.vue?vue&type=script&lang=jsx&setup=true"

import "./associate.vue?vue&type=style&index=0&id=f035d4c6&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f035d4c6"]])

export default __exports__